export default {
  badge: 'Coming Soon',
  hero_label: 'Own Service',
  hero_title: 'GenAI All In One Tool',
  hero_desc: 'All generative AI in one platform.\nThe next-generation tool to accelerate your enterprise AI adoption.',
  overview_label: 'OVERVIEW',
  overview_title: 'Unify all your AI tools into one.',
  overview_desc: 'ChatGPT, Claude, Gemini, image generation, speech recognition, data analysis—\nManaging separately contracted AI tools is inefficient.\nAIX JAPAN\'s "GenAI All In One Tool" integrates all AI capabilities\ninto a single platform, accelerating AI adoption across your entire team.',
  features_label: 'FEATURES',
  features_title: '6 Core Functions',
  feature_1_tag: 'TEXT',
  feature_1_title: 'Multi-AI Chat',
  feature_1_desc: 'Switch between major large language models including GPT-4o, Claude 3.5, and Gemini 1.5 from a single screen. Compare models to achieve optimal output.',
  feature_2_tag: 'IMAGE',
  feature_2_title: 'Image Generation & Editing',
  feature_2_desc: 'Compatible with DALL-E 3, Stable Diffusion XL, and Midjourney API. Generate high-quality images from text prompts with inpainting and style transfer support.',
  feature_3_tag: 'VOICE',
  feature_3_title: 'Voice & Transcription',
  feature_3_desc: 'High-precision voice transcription using Whisper, combined with text-to-speech (TTS) capabilities. Instantly complete meeting transcripts and interview write-ups.',
  feature_4_tag: 'DOCUMENT',
  feature_4_title: 'AI Document Creation',
  feature_4_desc: 'AI automatically generates reports, proposals, and presentation materials. Simply select a template to create professional-quality business documents in minutes.',
  feature_5_tag: 'ANALYTICS',
  feature_5_title: 'Data Analysis & Visualization',
  feature_5_desc: 'Simply upload CSV or Excel files, and AI automatically analyzes data and generates charts and insights. No specialized knowledge required for data utilization.',
  feature_6_tag: 'AGENT',
  feature_6_title: 'AI Agent',
  feature_6_desc: 'AI agent that autonomously executes tasks. Automate complex business workflows by combining web search, file operations, and API integrations.',
  interface_label: 'INTERFACE',
  interface_title: 'Simple and Intuitive\nSingle Operating Screen',
  interface_1: 'Integrated dashboard for instant access to all AI tools',
  interface_2: 'Centralized management of team usage and costs',
  interface_3: 'Cross-search through all conversation and generation history',
  interface_4: 'Permission management to ensure security',
  interface_5: 'Responsive UI compatible with both PC and smartphones',
  usecases_label: 'USE CASES',
  usecases_title: 'Applicable Across Roles and Departments',
  usecase_1_role: 'Marketer',
  usecase_1_item_1: 'Mass generation of social media posts and ad copy',
  usecase_1_item_2: 'Production of banner images and creative materials',
  usecase_1_item_3: 'Automated creation of competitive research and market analysis reports',
  usecase_2_role: 'Business Professional',
  usecase_2_item_1: 'Instantly create draft proposals and project plans',
  usecase_2_item_2: 'Automated meeting transcription and summarization',
  usecase_2_item_3: 'Streamline internal reports and status updates',
  usecase_3_role: 'Engineer',
  usecase_3_item_1: 'Assistance with code reviews and bug fixes',
  usecase_3_item_2: 'Generation of API specifications and technical documentation',
  usecase_3_item_3: 'Automated generation of test code and design documents',
  usecase_4_role: 'Management',
  usecase_4_item_1: 'Data analysis for management dashboards',
  usecase_4_item_2: 'Draft creation for business plans and budget materials',
  usecase_4_item_3: 'Knowledge sharing for internal AI adoption promotion',
  pricing_label: 'PRICING',
  pricing_title: 'Pricing Plans',
  pricing_subtitle: 'All plans include a 14-day free trial. No credit card required.',
  plan_starter_name: 'Starter',
  plan_starter_name_ja: 'Starter',
  plan_starter_price: '¥3,980',
  plan_starter_period: '/mo (tax incl.)',
  plan_starter_desc: 'For individuals and small teams. Perfect for those starting to explore AI.',
  plan_starter_cta: 'Start Free Trial',
  plan_pro_name: 'Pro',
  plan_pro_name_ja: 'Pro',
  plan_pro_price: '¥12,800',
  plan_pro_period: '/mo (tax incl.)',
  plan_pro_desc: 'For SMEs and serious teams. Full access to all features.',
  plan_pro_cta: 'Start Free Trial',
  plan_enterprise_name: 'Enterprise',
  plan_enterprise_name_ja: 'Enterprise',
  plan_enterprise_price: 'Contact Us',
  plan_enterprise_period: '',
  plan_enterprise_desc: 'For large enterprises and organizations with custom requirements. Includes dedicated support.',
  plan_enterprise_cta: 'Contact Us',
  plan_recommended: 'RECOMMENDED',
  plan_starter_features: ['Multi-AI Chat (200 times/mo)', 'Image Generation (50 images/mo)', 'Voice Transcription (60 min/mo)', 'AI Document Creation (20 items/mo)', 'Email Support'],
  plan_pro_features: ['Multi-AI Chat (Unlimited)', 'Image Generation (500 images/mo)', 'Voice Transcription (Unlimited)', 'AI Document Creation (Unlimited)', 'Data Analysis & Visualization', 'AI Agent (100 tasks/mo)', 'Priority Chat Support'],
  plan_enterprise_features: ['Unlimited Access to All Features', 'Custom AI Agent Development', 'SSO / SAML Authentication', 'Dedicated Cloud Environment', 'SLA Guarantee', 'Dedicated Customer Success', 'Onboarding Support'],
  faq_label: 'FAQ',
  faq_title: 'Frequently Asked Questions',
  faq_q1: 'Is there a free trial?',
  faq_a1: 'Yes, we offer a 14-day free trial for all plans. No credit card required—start immediately.',
  faq_q2: 'Can I choose which AI model to use?',
  faq_a2: 'Yes, users can freely switch between major models such as GPT-4o, Claude 3.5 Sonnet, and Gemini 1.5 Pro.',
  faq_q3: 'Is my data used for AI training?',
  faq_a3: 'No. Your data is never used for training any AI models. The Enterprise plan also offers dedicated environments.',
  faq_q4: 'Can it integrate with existing in-house systems?',
  faq_a4: 'Integration via API is available with Slack, Notion, Google Workspace, Salesforce, and more. Custom integrations are also available on the Enterprise plan.',
  faq_q5: 'Can I change or cancel my plan mid-term?',
  faq_a5: 'You can upgrade, downgrade, or cancel your plan at any time. Annual plans are refunded on a pro-rated basis.',
  cta_label: 'GET STARTED',
  cta_title: 'Try it free for 14 days',
  cta_desc: 'No credit card required. Experience all features right away.\nFeel free to contact us with any questions.',
  cta_trial: 'Start Free Trial',
  cta_contact: 'Demo & Inquiry',
  flow_label: 'FLOW',
  flow_title: 'How to Get Started',
  flow_intro: 'From inquiry to company-wide adoption, we clarify what happens and what we need from you at each step.',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-chat-3-line',
      title: 'Inquiry & Free Consultation',
      note: 'Free',
      duration: 'Same day at the earliest',
      activities: [
        'Interview on purpose, organization size, and security requirements',
        'Plan recommendation and demo',
      ],
      deliverables: ['Plan proposal and quotation'],
      clientAsks: ['Expected number of users and use cases'],
    },
    {
      no: '02',
      icon: 'ri-flask-line',
      title: 'Free Trial',
      note: '14 days',
      duration: '14 days',
      activities: [
        'Trial with a small team to confirm usability and impact in real work',
        'Consultation on how to make the most of it',
      ],
      deliverables: ['Trial environment with all features'],
      clientAsks: ['Selection of the trial team', 'Usage feedback'],
    },
    {
      no: '03',
      icon: 'ri-settings-4-line',
      title: 'Rollout & Initial Setup',
      duration: 'approx. 1 week',
      activities: [
        'Account issuance, organization setup, and permission design',
        'Usage-rule setup and an orientation for administrators',
      ],
      deliverables: ['Production environment', 'Administrator setup guide'],
      clientAsks: ['Decision on usage rules', 'Member list'],
    },
    {
      no: '04',
      icon: 'ri-customer-service-2-line',
      title: 'Adoption Support',
      duration: 'Ongoing',
      activities: [
        'Usage proposals based on how your team actually uses it',
        'New feature announcements and support desk',
      ],
      deliverables: ['Support desk', 'Usage proposals'],
      clientAsks: ['Periodic sharing of usage status'],
    },
  ],
};
